import { css } from "lit";
export default css `
    :host {
        display: flex;
        column-gap: 10px;
        position: relative;
        background-color: var(--terminal-background);
        margin: 0;
        overflow: hidden;
        padding: 1rem 0 1rem 0;
        border: 1px dashed var(--code-border);
        color: var(--terminal-text);
        text-shadow: 0 0 10px var(--terminal-text-shadow);
        overflow-x: auto;
    }

    pre {
        margin: 0;
        padding-left: 0;
        overflow-x: auto;
    }

    :host::before {
        padding-left: 1rem;
        content: ">";
        font-family: var(--font-stack-bold);
        color: var(--secondary-color)
    }

    sl-button.copy {
        position: absolute;
        right: 10px;
        top: 10px;
    }

    sl-button.copy::part(base) {
        color: var(--primary-color);
        border: 1px solid var(--code-border);
        font-family: var(--font-stack), serif;
        border-radius: 0;
        text-transform: uppercase;
    }

    @media only screen and (max-width: 1000px) {
        
        sl-button {
            display: none;
        }
    }
    
`;
